(function () {
  'use strict';

  if (window.innerWidth > 767) return;

  var MAX_WAIT = 10000;
  var POLL     = 300;
  var elapsed  = 0;

  var poller = setInterval(function () {
    elapsed += POLL;
    var wrapper = document.querySelector('.mcf-wrapper');
    if (wrapper) {
      clearInterval(poller);
      init(wrapper);
    } else if (elapsed >= MAX_WAIT) {
      clearInterval(poller);
    }
  }, POLL);

  function init(wrapper) {
    var clearWrapper = wrapper.querySelector('.mcf-clear-wrapper');
    var clearBtn     = wrapper.querySelector('.mcf-clear-btn');

    /* ── 1. Dropdown toggle ─────────────────────────────── */
    wrapper.querySelectorAll('.mcf-group').forEach(function (group) {
      var btn      = group.querySelector('.mcf-btn');
      var dropdown = group.querySelector('.mcf-dropdown');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = group.classList.contains('mcf-open');
        closeAllGroups();
        if (!isOpen) openGroup(group, btn, dropdown);
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) closeAllGroups();
    });

    window.addEventListener('scroll', closeAllGroups, { passive: true });

    /* ── 2. Item selection ──────────────────────────────── */
    wrapper.querySelectorAll('.mcf-dropdown').forEach(function (dropdown) {
      dropdown.querySelectorAll('.mcf-item').forEach(function (item) {
        item.addEventListener('click', function () {

          dropdown.querySelectorAll('.mcf-item').forEach(function (i) {
            i.classList.remove('mcf-active');
          });
          item.classList.add('mcf-active');

          var tagHandle = item.getAttribute('data-tag');

          var checkbox = document.querySelector(
            '#collection-filter-drawer .Collapsible__Content .Linklist .Linklist__Item input[data-tag="' + tagHandle + '"]'
          );

          if (checkbox) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            applyTagsWhenReady();
          }

          closeAllGroups();
          if (clearWrapper) clearWrapper.style.display = 'flex';
        });
      });
    });

    /* ── 3. Clear filter ────────────────────────────────── */
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        var resetBtn = document.querySelector('button.ButtonGroup__Item[data-action="reset-tags"]');
        if (resetBtn) resetBtn.click();

        wrapper.querySelectorAll('.mcf-item.mcf-active').forEach(function (el) {
          el.classList.remove('mcf-active');
        });

        if (clearWrapper) clearWrapper.style.display = 'none';
      });
    }

    /* ── 4. Empty-state reset button (AJAX-rendered) ────── */
    var mo = new MutationObserver(function () {
      var emptyBtn = document.querySelector('button.EmptyState__Action');
      if (emptyBtn && !emptyBtn._mcfBound) {
        emptyBtn._mcfBound = true;
        emptyBtn.addEventListener('click', function () {
          wrapper.querySelectorAll('.mcf-item.mcf-active').forEach(function (el) {
            el.classList.remove('mcf-active');
          });
          if (clearWrapper) clearWrapper.style.display = 'none';
        });
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    /* ── 5. Sync active state from URL on load ──────────── */
    try {
      var tagSegment = window.location.pathname.split('/').slice(3).join('/');
      if (tagSegment) {
        var activeTags = tagSegment.split('+');
        var anyActive  = false;
        wrapper.querySelectorAll('.mcf-item').forEach(function (item) {
          if (activeTags.indexOf(item.getAttribute('data-tag')) !== -1) {
            item.classList.add('mcf-active');
            anyActive = true;
          }
        });
        if (anyActive && clearWrapper) clearWrapper.style.display = 'flex';
      }
    } catch (e) {}
  }

  /**
   * Instead of a fixed 1200ms wait, poll until the Apply button is
   * enabled and the drawer checkbox state has settled, then click immediately.
   * Falls back to 600ms if the button never becomes ready.
   */
  function applyTagsWhenReady() {
    var applyBtn = document.querySelector('button.ButtonGroup__Item[data-action="apply-tags"]');
    if (!applyBtn) return;

    var READY_POLL    = 50;   /* check every 50ms   */
    var READY_TIMEOUT = 600;  /* fallback after 600ms */
    var waited        = 0;

    /* If the theme disables the button while processing, wait for it
       to become enabled again before clicking.                        */
    var readyPoller = setInterval(function () {
      waited += READY_POLL;

      var isDisabled = applyBtn.disabled || applyBtn.getAttribute('aria-disabled') === 'true';

      if (!isDisabled || waited >= READY_TIMEOUT) {
        clearInterval(readyPoller);
        applyBtn.click();
      }
    }, READY_POLL);
  }

  /* ── Helpers ────────────────────────────────────────────── */
  function openGroup(group, btn, dropdown) {
    group.classList.add('mcf-open');
    btn.setAttribute('aria-expanded', 'true');
    dropdown.removeAttribute('hidden');
  }

  function closeGroup(group) {
    var btn      = group.querySelector('.mcf-btn');
    var dropdown = group.querySelector('.mcf-dropdown');
    group.classList.remove('mcf-open');
    if (btn)      btn.setAttribute('aria-expanded', 'false');
    if (dropdown) dropdown.setAttribute('hidden', '');
  }

  function closeAllGroups() {
    document.querySelectorAll('.mcf-group.mcf-open').forEach(closeGroup);
  }

}());

/* Desktop Filter */
(function () {
  "use strict";

  var filterGroup = document.querySelector("[data-op-pt-484-filter-group]");
  if (!filterGroup) return;

  document.body.classList.add("OP_PT_484_native");

  // ---------------------------------------------------------------------
  // Height tracking (for the sticky offset in the CSS)
  // ---------------------------------------------------------------------
  function updateHeightVar() {
    document.documentElement.style.setProperty(
      "--op-pt-484-filter-height",
      filterGroup.offsetHeight + "px"
    );
  }
  updateHeightVar();
  new ResizeObserver(updateHeightVar).observe(filterGroup);

  function getCurrentTags() {
    var parts = window.location.pathname.split("/");
    return parts.length > 3 ? decodeURIComponent(parts[parts.length - 1]).split("+") : [];
  }

  var CROSS_COUNTS = {
    "immune-support": { botanicals: 6, minerals: 0, supplements: 3 },
    "radiant-skin": { botanicals: 3, minerals: 1, supplements: 3 },
    digestion: { botanicals: 8, minerals: 0, supplements: 0 },
    energy: { botanicals: 12, minerals: 0, supplements: 0 },
    sleep: { botanicals: 0, minerals: 1, supplements: 2 },
    hydration: { botanicals: 0, minerals: 3, supplements: 2 },
    metabolism: { botanicals: 3, minerals: 0, supplements: 0 },
    longevity: { botanicals: 4, minerals: 0, supplements: 1 },
    botanicals: { "immune-support": 6, "radiant-skin": 3, digestion: 8, energy: 12, sleep: 0, hydration: 0, metabolism: 3, longevity: 4 },
    minerals: { "immune-support": 0, "radiant-skin": 1, digestion: 0, energy: 0, sleep: 1, hydration: 3, metabolism: 0, longevity: 0 },
    supplements: { "immune-support": 3, "radiant-skin": 3, digestion: 0, energy: 0, sleep: 2, hydration: 2, metabolism: 0, longevity: 1 },
  };

  var HEALTH_BENEFIT_TAGS = ["immune-support", "radiant-skin", "digestion", "energy", "sleep", "hydration", "metabolism", "longevity"];
  var PRODUCT_TYPE_TAGS = ["botanicals", "minerals", "supplements"];

  function getCategory(tag) {
    if (HEALTH_BENEFIT_TAGS.indexOf(tag) !== -1) return "HEALTH_BENEFIT";
    if (PRODUCT_TYPE_TAGS.indexOf(tag) !== -1) return "PRODUCT_TYPE";
    return null;
  }

  function syncPills() {
    var currentTags = getCurrentTags();
    var options = Array.prototype.slice.call(filterGroup.querySelectorAll(".OP_PT_484_Option"));

    // Active state
    options.forEach(function (opt) {
      var tag = opt.getAttribute("data-tag");
      opt.classList.toggle("OP_PT_484_Option_Active", currentTags.indexOf(tag) !== -1);
    });

    var activeOptions = options.filter(function (opt) {
      return opt.classList.contains("OP_PT_484_Option_Active");
    });

    if (activeOptions.length > 1) {
      var productList = document.querySelector(".CollectionInner__Products");
      var visibleCount = productList ? productList.querySelectorAll(".ProductListWrapper .ProductItem").length : 0;
      activeOptions.forEach(function (opt) {
        var countEl = opt.querySelector(".OP_PT_484_OptionCount");
        if (countEl) countEl.textContent = "(" + visibleCount + ")";
      });
    }
    var activeHealthTag = activeOptions
      .map(function (o) { return o.getAttribute("data-tag"); })
      .find(function (t) { return getCategory(t) === "HEALTH_BENEFIT"; });
    var activeProductTag = activeOptions
      .map(function (o) { return o.getAttribute("data-tag"); })
      .find(function (t) { return getCategory(t) === "PRODUCT_TYPE"; });

    options.forEach(function (opt) {
      if (opt.classList.contains("OP_PT_484_Option_Active")) return;

      var tag = opt.getAttribute("data-tag");
      var category = getCategory(tag);
      var crossCount = null;

      if (category === "HEALTH_BENEFIT" && activeProductTag && CROSS_COUNTS[activeProductTag]) {
        crossCount = CROSS_COUNTS[activeProductTag][tag];
      } else if (category === "PRODUCT_TYPE" && activeHealthTag && CROSS_COUNTS[activeHealthTag]) {
        crossCount = CROSS_COUNTS[activeHealthTag][tag];
      }

      var countEl = opt.querySelector(".OP_PT_484_OptionCount");
      if (!countEl) return;

      if (crossCount !== null && crossCount !== undefined) {
        countEl.textContent = "(" + crossCount + ")";
      } else {
        // Fall back to this pill's own standalone count (rendered by
        // Liquid into data-count on first load).
        var baseCount = opt.getAttribute("data-count");
        if (baseCount !== null) countEl.textContent = "(" + baseCount + ")";
      }
    });
  }
  var recentlyClicked = new Set();

  filterGroup.querySelectorAll(".OP_PT_484_Option").forEach(function (opt) {
    opt.addEventListener("click", function () {
      var tag = opt.getAttribute("data-tag");
      if (recentlyClicked.has(tag)) return;

      var realControl = document.querySelector(
        '.CollectionFilter_Custom [data-action="toggle-tag"][data-tag="' + tag + '"], ' +
        '.CollectionFilters input[name="fliter_tag"][data-tag="' + tag + '"]'
      );

      if (!realControl) return;

      recentlyClicked.add(tag);
      setTimeout(function () { recentlyClicked.delete(tag); }, 500);
      realControl.click();
      setTimeout(syncPills, 100);
    });
  });
  var productList = document.querySelector(".CollectionInner__Products");
  if (productList) {
    new MutationObserver(syncPills).observe(productList, { childList: true, subtree: true });
  }

  window.addEventListener("popstate", function () {
    setTimeout(syncPills, 100);
  });
})();